import { faPaperclip } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { BidSectionContainer, StyledVehicleBidBuyInformation } from 'modules/BuyerActivity/VehicleAuction.styled'
import { PopoverAttachment } from 'modules/PopoverAttachment'
import { VDPHistory } from 'modules/VDP/VDPHistory'
import { StyledVehicleDetailsBody, StyledVehicleDetailsHeaderRow } from 'modules/VehicleList'
import { useContext } from 'react'
import { Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap'
import { useLocation } from 'react-router-dom'
import { IVDPSearchParams } from 'types/ISearchParams'
import { IVehicleData } from 'types/vehicleTypes'
import { parseUrlSearchParams } from 'utils/urlParams'

import { UserMaxBid } from './UserMaxBid'
import { VehicleActions } from './VehicleActions'
import { VehicleBidBuyActions } from './VehicleBidBuyActions'
import { VehicleBidHistoryLink } from './VehicleBidHistoryLink'
import { VehicleContext } from './VehicleContext'
import { AnnouncementIcon, PaperClipButton, VehicleNoteContainer, VehicleVin } from './VehicleDetails.styled'
import { VehicleNote } from './VehicleNote'
import { VehiclePriceSection } from './VehiclePriceSection'
import { VehicleProperties } from './VehicleProperties'
import { VehicleTags } from './VehicleTags'
import { VehicleTimer } from './VehicleTimer'
import { VehicleTitleSection } from './VehicleTitleSection'
import { useGlobalStore } from 'store/useGlobalStore'
export interface IProps {
  vehicleData: IVehicleData
}
export const VehicleInformation = ({ vehicleData }: IProps) => {
  const location = useLocation()
  const isVdpHistory = parseUrlSearchParams<IVDPSearchParams>(location.search).history === 'true'
  const hideBuyOptions = parseUrlSearchParams<IVDPSearchParams>(location.search).history === 'true'
  const { retailView } = useContext(VehicleContext)
  const [assetFolder] = useGlobalStore((state) => [state.userClaims.CurrentBuyerTypeAssetFolder])

  return (
    <StyledVehicleDetailsBody>
      <StyledVehicleDetailsHeaderRow>
        <>
          <VehicleTitleSection vehicleData={vehicleData} />
        </>
        <Col sm={'auto'} className="d-print-none vehicle-action">
          <VehicleActions vehicleData={vehicleData} />
        </Col>
      </StyledVehicleDetailsHeaderRow>
      <Row>
        <Col md={8}>
          <VehicleVin>
            {vehicleData.vehicle.VIN}
            {vehicleData.vehicle.HasExternalAttachments && !isVdpHistory && (
              <OverlayTrigger
                placement="bottom"
                trigger="click"
                rootClose
                overlay={(props) => (
                  <PopoverAttachment
                    VIN={vehicleData.vehicle.VIN}
                    vehicleInstanceID={vehicleData.vehicle.InstanceID}
                    {...props}
                  />
                )}
              >
                <PaperClipButton variant="link">
                  <FontAwesomeIcon icon={faPaperclip} title="Click Here to View Attachments" />
                </PaperClipButton>
              </OverlayTrigger>
            )}
          </VehicleVin>
          {!retailView && <span>{vehicleData.vehicle.SaleChannelName}</span>}
          <VehicleProperties vehicleInfo={vehicleData.vehicle} />
          <VehicleNoteContainer>
            {(vehicleData.showAnnouncementRecall ||
              (vehicleData.Recalls &&
                vehicleData.Recalls.RecallDetails &&
                vehicleData.Recalls.RecallDetails.length > 0)) && (
              <OverlayTrigger placement="right" overlay={<Tooltip id="recall-tooltip">Open Recall(s)</Tooltip>}>
                <AnnouncementIcon assetFolder={assetFolder} />
              </OverlayTrigger>
            )}
            <VehicleNote />
          </VehicleNoteContainer>
        </Col>
        {hideBuyOptions && vehicleData.PurchaseHistory ? (
          <Col md={4}>
            <VDPHistory vehiclePurchase={vehicleData.PurchaseHistory} />
          </Col>
        ) : (
          <>
            {!retailView && (
              <Col md>
                <StyledVehicleBidBuyInformation>
                  <VehiclePriceSection />
                  <VehicleTags />
                  {vehicleData.auctionInfo !== undefined && (
                    <>
                      <VehicleBidHistoryLink />
                      <div className="v-timer">
                        <VehicleTimer />
                      </div>
                    </>
                  )}
                  <BidSectionContainer>
                    {vehicleData.auctionInfo !== undefined && <UserMaxBid />}
                    <VehicleBidBuyActions />
                  </BidSectionContainer>
                </StyledVehicleBidBuyInformation>
              </Col>
            )}
          </>
        )}
      </Row>
    </StyledVehicleDetailsBody>
  )
}
